import { useQuery } from '@tanstack/react-query';
import api from '../api/client.js';

// Polls the ETL freshness sentinel. Returns the ledger-sync job status (or null).
export default function useDataFreshness() {
  const { data } = useQuery({
    queryKey: ['data-freshness'],
    queryFn: () => api.get('/system/data-freshness').then(r => r.data.data),
    refetchInterval: 10 * 60 * 1000, // 10 min
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  return data?.['ledger-sync'] ?? null;
}
